import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { FormActions, Select } from '../../../common/components/formControls';
import TermsDropdownList from '../../terms/DropdownList';
import CentersDropdownList from '../../centers/DropdownList';

class Filter extends Component {

	render() {
		const { handleSubmit, pristine, submitting, t, onTermSelected, onCenterSelected, kindergarten, heading } = this.props;
		return (
			<Panel>
				<Panel.Heading>{heading || t('WeeklyProgramCalendar_Filter')}</Panel.Heading>
				<Panel.Body>
					<form onSubmit={handleSubmit}>
						<Row>
							<Col sm={6}>
								<CentersDropdownList render='field' name='centerId'
									filter={(center) => center.isKindergarten === kindergarten && center.isOnline && center.territory && center.territory.isOnline}
									defaultSelection='first' hideEmptyOption={true}
									onChange={onCenterSelected}
									label={t('WeeklyProgram_Center')} />
							</Col>
							<Col sm={6}>
								<TermsDropdownList render='field' name='termId' defaultSelection='active' onChange={onTermSelected} label={t('WeeklyProgram_Term')} hideEmptyOption={true}/>
							</Col>
						</Row>

						<FormActions>
							<Button type='submit' disabled={submitting} bsStyle='primary'>{t('WeeklyProgramCalendar_FilterSubmit')}</Button>
						</FormActions>
					</form>
				</Panel.Body>
			</Panel>
		);
	}
}

export default reduxForm({ form: 'ChildAttendanceFilter' })(Filter);